module.exports = __webpack_public_path__ + "static/img/5953_phase_function_Paper_Points.567e67b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5953_phase_function_Paper_Points.png
// module id = 2RA+
// module chunks = 0